import * as React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { IStore } from '../../../../../../redux/IStore';
import {flow} from 'lodash';
import { IPolicyApplication, IProduct, IQuotes } from '../../../../../../data/api/models';
import { II18nMessages } from '../../../../../../services/branding/models';
import * as moment from 'moment';
import {displayCurrency, getAvailableQuote} from '../../../../../../util/helpers';
import {Col, Row} from 'react-bootstrap';
import SaveQuoteModal from '../../../../components/SaveQuoteModal';

interface ISidebarQuoteSummary {
  i18n: II18nMessages;
  policyApplication: IPolicyApplication;
  values: IPolicyApplication;
  product: IProduct;
  quotes: IQuotes;
  channel: any;
  quote: any;
  isAdditionalCover: boolean;
}

class SidebarQuoteSummary extends React.Component<ISidebarQuoteSummary> {
  private renderQuoteReference = () => {
    const { values } = this.props;

    return (
      <>
        {values.quoteReference && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                Your Reference:
              </Col>
              <Col sm={6} className="align-right">
                {values.quoteReference}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderDates = () => {
    const { values } = this.props;

    let content = null;

    if (values.startDate && values.endDate) {
      content = (
        <div>
          {values.startDate} to {moment(values.endDate).format('DD/MM/YYYY')}
        </div>
      );
    }

    return (
      <>
        {content && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                Cover Dates:
              </Col>
              <Col sm={6} className="align-right">
                {content}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderType = () => {
    const { values } = this.props;

    return (
      <>
        {values.personalCustomerString && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                Type:
              </Col>
              <Col sm={6} className="align-right">
                {values.personalCustomer ? 'Individual' : 'Company'}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderVehicles = () => {
    const { values } = this.props;

    return (
      <>
        {values.vehicleCount > 0 && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                Vehicle(s):
              </Col>
              <Col sm={6} className="align-right">
                Agricultural x {values.vehicleCount}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderDrivers = () => {
    const { values } = this.props;

    return (
      <>
        {values.driverCount > 0 && values.drivers[0].firstName && values.drivers[0].lastName && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                Driver(s):
              </Col>
              <Col sm={6} className="align-right">
                {values.drivers[0].title} {values.drivers[0].firstName} {values.drivers[0].lastName}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderGrossPremium = () => {
    const { quote } = this.props;

    const availableQuote = getAvailableQuote(quote);

    return (
      <>
        {availableQuote.length > 0 && availableQuote[0].gross > 0 && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                Total Premium:
              </Col>
              <Col sm={6} className="align-right">
                £{displayCurrency(availableQuote[0].gross, ',')}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderIPT = () => {
    const { quote } = this.props;

    const availableQuote = getAvailableQuote(quote);

    return (
      <>
        {availableQuote.length > 0 && availableQuote[0].tax > 0 && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={6}>
                IPT (inc {availableQuote[0].taxRate}%):
              </Col>
              <Col sm={6} className="align-right">
                £{displayCurrency(availableQuote[0].tax, ',')}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private renderExcess = () => {
    const { values } = this.props;

    const excess: number = parseInt(values.voluntaryExcess, 10) +
      (values.compulsoryExcess ? parseInt(values.compulsoryExcess, 10) : 100);

    return (
      <div className="margin-bottom">
        <Row>
          <Col sm={6}>
            Excess
          </Col>
          <Col sm={6} className="align-right">
            £{displayCurrency(excess, ',')}
          </Col>
        </Row>
      </div>
    );
  }

  private renderSaveButton = () => {
    const { quote } = this.props;

    return (
      <>
        {!quote.complete && (
          <div className="sidebar-layout">
            <Row>
              <Col sm={12}>
                <SaveQuoteModal {...this.props}/>
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  public render() {
    // const { values } = this.props;
    return (
      <div>
        {/*{values.quoteReference && (*/}
          {/*<div className="sub-content-container">*/}
            {/*<h3>Quote Summary</h3>*/}
            {/*{this.renderQuoteReference()}*/}
            {/*{this.renderDates()}*/}
            {/*{this.renderType()}*/}
            {/*{this.renderVehicles()}*/}
            {/*{this.renderDrivers()}*/}
            {/*{this.renderIPT()}*/}
            {/*{this.renderGrossPremium()}*/}
            {/*{this.renderExcess()}*/}
            {/*{this.renderSaveButton()}*/}
          {/*</div>*/}
        {/*)}*/}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes, complete } = state.quote;
      const values = selector(
        state,
        'quote',
        'startDate',
        'endDate',
        'tripType',
        'schemeId',
        'quoteReference',
        'personalCustomer',
        'personalCustomerString',
        'vehicleCount',
        'driverCount',
        'drivers',
        'voluntaryExcess',
        'compulsoryExcess',
      );

      return {
        i18n: state.branding.i18n,
        quote: state.quote,
        channel: state.branding.channel,
        policyApplication: state.quote.application,
        values,
        quotes,
        complete,
      };
    },
  ),
])(SidebarQuoteSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/QuoteSidebar/components/SidebarQuoteSummary/index.tsx